module.exports = __webpack_public_path__ + "static/media/yarn.74a9c688.svg";